/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { SignupStepDto, SignupStepType } from '@well/domain';
import {
  signupAccountTypeStepSegment,
  signupContactStepSegment,
  signupPaymentMethodPendingSegment,
  signupRouterSegment,
  signupStepSegment,
  signupSubscriptionStepSegment
} from '@well/navigation';

@Injectable({providedIn: 'root'})
export class SignupStepUrlMapperService{

  constructor() {
  }

  getUrlToNextStep(signupStep: SignupStepDto): string{

    const urlPrefix = `/${signupRouterSegment}/${signupStepSegment}`;

    switch(signupStep.signupStepType){
      case SignupStepType.initial_step: {
        return `${urlPrefix}/${signupAccountTypeStepSegment}`;
      }

      case SignupStepType.legal_entity_step: {
        return `${urlPrefix}/${signupSubscriptionStepSegment}/${signupStep.legalEntityUuid}`;
      }

      case SignupStepType.subscription_plan_step: {
        return `${urlPrefix}/${signupPaymentMethodPendingSegment}/${signupStep.legalEntityUuid}`;
      }

      case SignupStepType.payment_method_pending_step: {
        return `${urlPrefix}/${signupContactStepSegment}/${signupStep.legalEntityUuid}`;
      }

    }

    return urlPrefix;

  }

}
